import { selectEnvironment } from '@cca/util';

import { env } from '../env';

import mmatProfile from './profiles/mmat';
import mmbeFrProfile from './profiles/mmbe-fr';
import mmbeNlProfile from './profiles/mmbe-nl';
import mmdeProfile from './profiles/mmde';
import mmesProfile from './profiles/mmes';
import mmnlProfile from './profiles/mmnl';
import sedeProfile from './profiles/sede';

const environment = selectEnvironment(
  {
    mmde: mmdeProfile,
    sede: sedeProfile,
    mmes: mmesProfile,
    mmat: mmatProfile,
    mmnl: mmnlProfile,
    mmbenl: mmbeNlProfile,
    mmbefr: mmbeFrProfile,
  },
  env.REACT_APP_CCA_PROFILE,
  env.REACT_APP_CCA_ENV,
);

export default environment;
